(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("takeExamSummary", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/exam/takeExamSummaryView.html",
            controller: ["authService", "takeExamResource", "messageService", "$anchorScroll", "$state", "$scope", "$timeout", TakeExamSummaryCtrl],
            controllerAs: "vm"
        };
        function TakeExamSummaryCtrl(authService, takeExamResource, messageService, $anchorScroll, $state, $scope, $timeout) {
            var vm = this;
            vm.dataLoaded = false;
            vm.examInfo = angular.copy($state.params.examInfo);
            vm.learnerName = authService.authentication.userFirstName + " " + authService.authentication.userLastName;
            vm.questions = []; //model.questions;
            var delay = 250;
            // GET QUESTIONS
            takeExamResource.getTakeExamSummaryViewModel({ examAttemptId: vm.examInfo.examAttemptId }, function (model) {
                var questions = angular.copy(model.questions);
                if (vm.examInfo.isTimed) {
                    $scope.$broadcast("timer-set-countdown-seconds", model.timeLeft);
                }
                //20 or less questions = 250ms, otherwise calculate so that it takes 5 seconds max
                if (questions.length > 20)
                    delay = Math.round(5000 / questions.length);
                loadQuestion(questions);
                $timeout(function () {
                    vm.dataLoaded = true;
                });
            }, function (error) {
                messageService.error(error);
            });
            function loadQuestion(questions) {
                vm.questions.push(questions.shift());
                $timeout(function () {
                    $anchorScroll("bottom");
                });
                if (questions.length > 0) {
                    $timeout(function () {
                        loadQuestion(questions);
                    }, delay);
                }
                else {
                    vm.showSubmit = true;
                }
            }
            //////////////////////////////////////////////////////////////
            vm.goTo = function (order) {
                vm.examInfo.questionNumber = order;
                $state.go("main.accountExamQuestion", { examInfo: vm.examInfo });
            };
            vm.submitExam = function () {
                $state.go("main.accountExamResult", { examInfo: vm.examInfo });
            };
            //TIME EXPIRED
            vm.timeExpired = function () {
                vm.submitExam();
            };
        }
    });
}());
